import { forwardRef, useState } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  placeholder?: string;
}

export const MarkdownEditor = forwardRef<HTMLTextAreaElement, MarkdownEditorProps>(
  function MarkdownEditor({ value, onChange, rows = 12, placeholder }, ref) {
    const [mobileTab, setMobileTab] = useState<"write" | "preview">("write");

    return (
      <div>
        {/* Mobile tab toggle */}
        <div className="mb-2 flex gap-2 sm:hidden">
          <button
            type="button"
            onClick={() => setMobileTab("write")}
            className={`rounded-md px-3 py-1 text-xs font-medium ${
              mobileTab === "write"
                ? "bg-accent text-white"
                : "bg-card-alt text-text-muted hover:text-text-primary"
            }`}
          >
            Write
          </button>
          <button
            type="button"
            onClick={() => setMobileTab("preview")}
            className={`rounded-md px-3 py-1 text-xs font-medium ${
              mobileTab === "preview"
                ? "bg-accent text-white"
                : "bg-card-alt text-text-muted hover:text-text-primary"
            }`}
          >
            Preview
          </button>
        </div>

        {/* Split pane */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {/* Editor */}
          <div className={mobileTab === "preview" ? "hidden sm:block" : ""}>
            <label className="mb-1 block text-xs font-medium text-text-faint">Markdown</label>
            <textarea
              ref={ref}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              rows={rows}
              placeholder={placeholder}
              className="block w-full rounded-md border border-input-border bg-card px-3 py-2 font-mono text-sm text-text-primary focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
            />
          </div>

          {/* Preview */}
          <div className={mobileTab === "write" ? "hidden sm:block" : ""}>
            <label className="mb-1 block text-xs font-medium text-text-faint">Preview</label>
            <div
              className="overflow-y-auto rounded-md border border-border bg-surface px-3 py-2"
              style={{ minHeight: `${rows * 1.5 + 1}rem` }}
            >
              {value ? (
                <div className="prose prose-sm prose-neutral dark:prose-invert max-w-none">
                  <Markdown remarkPlugins={[remarkGfm]}>{value}</Markdown>
                </div>
              ) : (
                <p className="text-sm text-text-faint italic">Nothing to preview</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  },
);
